<template>
  <div class="game-message" v-if="gameData && gameData.match">
    <p v-if="message" class="has-text-danger">{{ message }}</p>
    <p v-else-if="flippable">
      <b-tooltip label="Flip board" type="is-primary">
        <b-button
          type="is-primary is-outlined"
          icon-left="retweet"
          @click="handleFlip"
        />
      </b-tooltip>
    </p>
  </div>
</template>

<script>
import { ONLINE_STATUS } from "@/constants";
import { hasCommenced } from "vue-chess-shared/utils/match-helper";

const TIMER_INTERVAL = 250;

export default {
  name: "GameMessage",

  props: {
    gameData: {
      type: Object,
      default: () => {},
    },
    flippable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      moveTime: 0,
    };
  },

  watch: {
    gameData() {
      this.moveTime = 0;
    },
  },

  computed: {
    message() {
      if (!this.gameData) {
        return null;
      }

      const {
        match,
        movesStats,
        leewayTimeLeft,
        playerColor,
        turnColor,
        opponent,
        opponentStatus,
      } = this.gameData;

      if (!match.createdAt) return;

      const commenced = hasCommenced(match, movesStats);

      if (!match.result && !commenced) {
        if (this.moveTime < leewayTimeLeft) {
          if (match.tournamentId) {
            return `${Math.round(
              leewayTimeLeft - this.moveTime
            )}s until timer auto-starts`;
          } else {
            return `${Math.round(
              leewayTimeLeft - this.moveTime
            )}s to play the first move`;
          }
        }
      }

      // match is playing, I'm a real player, and the opponent is offline
      // then I can claim victory if waiting time is over
      if (
        playerColor &&
        opponentStatus === ONLINE_STATUS.OFFLINE &&
        commenced &&
        !match.result &&
        turnColor !== playerColor
      ) {
        return `If ${opponent.first_name} doesn't come back in time, you can claim a victory.`;
      }

      return null;
    },
  },

  methods: {
    handleFlip() {
      this.$emit("onFlip");
    },
  },

  mounted() {
    this.timerId = setInterval(() => {
      if (!this.gameData) {
        return;
      }

      if (
        this.gameData.match &&
        (this.gameData.match.result || this.gameData.match.commencedAt)
      ) {
        this.moveTime = 0;
        return;
      }

      if (!this.gameData.timeData) {
        this.moveTime = 0;
        return;
      }

      const timeData = this.gameData.timeData[this.gameData.turnColor];

      if (!timeData) {
        this.moveTime = 0;
        return;
      }

      if (!timeData.isNextColor) {
        this.moveTime = 0;
        return;
      }

      this.moveTime += TIMER_INTERVAL / 1000;
    }, TIMER_INTERVAL);
  },

  beforeDestroy() {
    if (this.timerId) clearInterval(this.timerId);
  },
};
</script>

<style scoped>
.game-message {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
